define(function(require) {
	// general
	const CN = require('civicsUtils/constants');
	const InstrumentUtils = require('civicsUtils/instrument_utilities');
	const Utils = require('civicsUtils/general_utilities');
	const ViewManager = require('civicsUtils/view_manager');
	const AvailableFeatures = require('civicsUtils/available_features');

	// models
	const ReviewModel = require('civicsModels/review_model');

	// templates
	const tpl = require('civicsViews/assign_review/templates/t_itv_review_cancel_request.hbs');

	return Marionette.ItemView.extend({
		initialize: function(options) {
			this.config = options.config;
			this.model = options.model;
			this.serviceProvidersCollection = options.serviceProvidersCollection;
			this.modalRegion = options.modalRegion;
		},
		template: tpl,
		className: 'review-detail-modal',
		events: {
			'click @ui.btnBack': 'backClicked',
			'click @ui.btnClose': 'backClicked',
			'click @ui.btnCancelRequest': 'cancelRequestClicked'
		},
		ui:{
			btnBack:'.btn-back-confirmation',
			btnClose:'.bbm-btn-close',
			btnCancelRequest:'.btn-cancel-confirmation'
		},
		enableButtons: function(enable){
			this.ui.btnBack.prop('disabled', !enable);
			this.ui.btnCancelRequest.prop('disabled', !enable);
		},
		backClicked:function(){
			if(__DEV__) console.log('itv cancel request -- backClicked');
			this.triggerMethod('back:clicked');

			if(this.modalRegion) {
				this.modalRegion.hideModal();
			}
			else {
				this.destroy();
			}
		},
		cancelRequestClicked:function(){
			if(__DEV__) console.log('itv cancel request -- cancelRequestClicked');
			this.enableButtons(false);
			ViewManager.loading(true);
			var self = this;
			// 2016-03-04 PL:  Clear the assignedToProvider and scheduledDateTime (not 100% on clearing scheduledDataTime)
			this.model.set({
				'assignedToProvider':{id:1},
				'scheduledDateTime':CN.DATE_TIME_MIN_VAL
			});
			this.model.unset("attachments", {silent: true});			//Do not send Attachments, there is no need to since we can't update them.
			this.model.unset("reviewAttachments", {silent: true});

			this.model.save(null, {
				error: function(model, response, options){
					ViewManager.errorToWindow(response, this);
					ViewManager.loading(false);
					self.enableButtons(true);
				}
			})
			.done(function(response, status, xhrResponse) {
				if(__DEV__) console.log('itv cancel request -- cancelRequest done function after save model');
				ViewManager.loading(false);
				// 2016-02-11 PL:  Note, don't need to write to inspection log for customer view
				self.triggerMethod('cancelReviewRequestConfirmation:clicked');

				if(self.modalRegion) {
					self.modalRegion.hideModal();
				}
				else {
					self.destroy();
				}
			})
			.fail(function(response, status, xhrResponse){
				ViewManager.errorToWindow(response);
				ViewManager.loading(false);
				self.enableButtons(true);
			});
		},
		getProviderPhone: function() {
			var providers = this.serviceProvidersCollection.where({id:Number(this.model.get('assignedToProvider.id'))});
			return providers.length == 1 ? providers[0].get('dayPhone') : '';
		},
		getProviderMobilePhone: function() {
			var providers = this.serviceProvidersCollection.where({id:Number(this.model.get('assignedToProvider.id'))});
			return providers.length == 1 ? providers[0].get('mobileNumber') : '';
		},
		getProviderEmail: function() {
			var providers = this.serviceProvidersCollection.where({id:Number(this.model.get('assignedToProvider.id'))});
			return providers.length == 1 ? providers[0].get('eMailAddress') : '';
		},
		templateHelpers: function(){
			var self = this;
			return {
				modelId: self.model.get('id'),
				providerPhone: self.getProviderPhone(),
				providerMobilePhone: self.getProviderMobilePhone(),
				providerEmail: self.getProviderEmail(),
				showMobileNumber: AvailableFeatures.DisplayMobileNumber(),
				phoneLabel: AvailableFeatures.DisplayMobileNumber() ? i18n.t('CIVICS.COMMON.ALTERNATE_PHONE') : i18n.t('CIVICS.COMMON.PHONE'),
			};
		}
	});
});
